import {
  Alert,
  Button,
  Card,
  CardContent,
  Snackbar,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
//import Textarea from '@mui/joy/Textarea';
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import Loading from "../../../Includes/Loading";
import LoadingButton from "@mui/lab/LoadingButton";
import { styled } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { guardarPuesto, getInfPuesto } from "../Funciones/Puestos";
import validator from "validator";
import "../../../Lib/Funciones Generales/Prototipos";

const MySwal = withReactContent(Swal);

const Puesto = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [IsLoading, setIsLoading] = useState(true);
  const [IsGuardando, setIsGuardando] = useState(false);
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [Values, setValues] = useState({
    id: id ?? "0",
    nombre: "",
    sueldo_diario: "",
    descripcion: "",
    //jornada: "",
    //extras: "",
    comision: "",
  });
  const [Errores, setErrores] = useState({
    nombre: false,
    sueldo_diario: false,
    descripcion: false,
    //jornada: false,
    //extras: false,
    comision: false,
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handlInputChange = ({ target }) => {
    let Name = target.name;
    let Value = target.value;

    if (Name == "sueldo_diario" || Name == "comision") {
      Value = Value.toDecimal();
    } else if (Name == "jornada") {
      Value = Value.toNumber();
    }

    setValues({
      ...Values,
      [Name]: Value,
    });
    setErrores({
      ...Errores,
      [Name]: false,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    if (id != undefined) {
      getInfPuesto(id)
        .then((resp) => {
          //console.log(resp);
          if (resp?.err?.length == 0) {
            MySwal.fire({
              title: "Error",
              html: resp.mensaje,
              icon: "error",
              confirmButtonColor: "#3ABE88",
              showConfirmButton: true,
              allowEscapeKey: false,
              allowEnterKey: false,
              allowOutsideClick: false,
            }).then(() => {
              setIsLoading(false);
              navigate(-1);
            });
          } else {
            setValues(resp);
            setIsLoading(false);
          }
        })
        .catch((resp) => {
          MySwal.fire({
            title: "Error",
            html: resp.mensaje,
            icon: "error",
            confirmButtonColor: "#3ABE88",
            showConfirmButton: true,
            allowEscapeKey: false,
            allowEnterKey: false,
            allowOutsideClick: false,
          }).then(() => {
            setIsLoading(false);
            navigate(-1);
          });
          //setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, []);

  const GuardarPuesto = () => {
    setIsGuardando(true);
    guardarPuesto(Values, Errores, setErrores)
      .then((data) => {
        console.log(data);
        if (data.codigo == "200") {
          setIsGuardando(false);
          MySwal.fire({
            title: "Correcto",
            html: data.mensaje,
            icon: "success",
            confirmButtoColor: "#3ABE88",
            showConfirmButton: false,
            timer: 1700,
          }).then((result) => {
            navigate(-1);
          });
        } else {
          setMensaje(data.mensaje);
          setOpen(true);
          setIsGuardando(false);
        }
      })
      .catch((data) => {
        setMensaje(data.mensaje);
        setOpen(true);
        setIsGuardando(false);
      });
  };

  const StyledSnackbar = styled((props) => <Snackbar {...props} />)(
    ({ theme }) => ({
      "& .MuiSnackbar-root": {
        top: theme.spacing(15),
      },
    })
  );

  return (
    <>
      <StyledSnackbar
        direction="right"
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {mensaje}
        </Alert>
      </StyledSnackbar>
      <Button
        onClick={() => navigate(-1)}
        className="btn  font-AvenirBold my-4 text-star ps-0 pe-4  "
        variant="text"
      >
        <ArrowBackIcon className="me-3" />
        Puestos
      </Button>
      <Card elevation={3}>
        <CardContent className="p-0">
          <div className="p-3">
            <h6 className="mb-0 text-left font-AvenirBold">
              {id ? "Editar puesto" : "Nuevo puesto"}
            </h6>
          </div>
          <hr
            style={{ backgroundColor: "#DFDEE0", height: "1px", opacity: "1" }}
            className="m-0 p-0"
          />

          {IsLoading ? (
            <Row className="px-3">
              <Col sm={12} className="p-3">
                <Loading />
              </Col>
            </Row>
          ) : (
            <Row className="p-3">
              <Col sm={12} md={6} className="p-3">
                <TextField
                  fullWidth
                  name="nombre"
                  label="Nombre"
                  helperText={
                    Errores.nombre ? "Ingresa el nombre del puesto" : ""
                  }
                  inputProps={{ maxLength: 100 }}
                  variant="outlined"
                  value={Values.nombre}
                  error={Errores.nombre}
                  onChange={handlInputChange}
                />
              </Col>

              <Col sm={12} md={6} className="p-3">
                <TextField
                  multiline
                  fullWidth
                  name="descripcion"
                  label="Descripción"
                  maxRows={3}
                  inputProps={{ maxLength: 250 }}
                  value={Values.descripcion}
                  error={Errores.descripcion}
                  placeholder="Descripccion"
                  onChange={handlInputChange}
                  style={{ width: "100%", height: "55px" }}
                />
              </Col>

              <Col sm={12} md={6} className="p-3">
                <FormControl fullWidth>
                  <InputLabel htmlFor="outlined-adornment-amount">
                    Sueldo Diario
                  </InputLabel>
                  <OutlinedInput
                    startAdornment={
                      <InputAdornment position="start">$</InputAdornment>
                    }
                    name="sueldo_diario"
                    label="Sueldo Diario"
                    placeholder="Sueldo Diario"
                    variant="outlined"
                    value={Values.sueldo_diario}
                    error={Errores.sueldo_diario}
                    onChange={handlInputChange}
                  />
                  <FormHelperText
                    id="component-error-text"
                    error={Errores.sueldo_diario}
                  >
                    {Errores.sueldo_diario ? "Sueldo no valido" : ""}
                  </FormHelperText>
                </FormControl>
              </Col>

              <Col sm={12} md={6} className="p-3">
                <FormControl fullWidth>
                  <InputLabel htmlFor="outlined-adornment-amount">
                    Comisión
                  </InputLabel>
                  <OutlinedInput
                    startAdornment={
                      <InputAdornment position="start">%</InputAdornment>
                    }
                    //helperText={Errores.comision ? "Comisión no valida" : ""}
                    name="comision"
                    label="Comisión"
                    placeholder="Comisión"
                    value={Values.comision}
                    error={Errores.comision}
                    onChange={handlInputChange}
                  />
                  <FormHelperText
                    id="component-error-text"
                    error={Errores.comision}
                  >
                    {Errores.comision ? "Comisión no valida" : ""}
                  </FormHelperText>
                </FormControl>
              </Col>
            </Row>
          )}
          <Stack
            className="p-3"
            spacing={2}
            direction={{ xs: "column", sm: "row" }}
            style={{}}
          >
            <LoadingButton
              loading={IsGuardando}
              loadingPosition="start"
              disabled={IsLoading}
              onClick={() => GuardarPuesto()}
              className="btn btn-Kalendar font-AvenirMedium  py-2 px-4 "
              variant="contained"
              xs={{ with: "100$" }}
            >
              <span className={IsGuardando ? "px-4" : "px-2"}>
                {IsGuardando ? "Guardando..." : id ? "Guardar" : "Crear"}
              </span>
            </LoadingButton>
            <Button
              onClick={() => navigate(-1)}
              className="btn btn-cancelar font-AvenirMedium py-2 px-4"
              variant="outlined"
            >
              Cancelar
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
};

export default Puesto;
